import { render } from "./Criar.vue?vue&type=template&id=32e36212&scoped=true"
import script from "./Criar.vue?vue&type=script&lang=js"
export * from "./Criar.vue?vue&type=script&lang=js"

import "./Criar.vue?vue&type=style&index=0&id=32e36212&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e36212"]])

export default __exports__